import { createGlobalStyle } from 'styled-components';

export const DefaultStyle = createGlobalStyle`
	* {
		box-sizing: border-box;
	}
	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed, 
	figure, figcaption, footer, header, hgroup, 
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font-family: "Pretendard", sans-serif;
		vertical-align: baseline;
	}
	/* HTML5 display-role reset for older browsers */
	article, aside, details, figcaption, figure, 
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	body {
		line-height: 1;
		background-color:white;
		/* ios long press disabled */
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		/* scroll-bounce 효과 제거 테스트 */
		overscroll-behavior: none;
	}
	ol, ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}
	table {
		border-collapse: collapse;
		border-spacing: 0;
	}
`;

export const DefaultFont = createGlobalStyle`	
	@font-face {
		font-family: 'Pretendard';
		font-weight: 900;
		font-display: swap;
		src:local("Pretendard Black"), url("/Pretendard/Pretendard-Black.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 800;
		font-display: swap;
		src:local("Pretendard ExtraBold"), url("/Pretendard/Pretendard-ExtraBold.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 700;
		font-display: swap;
		src:local("Pretendard Bold"), url("/Pretendard/Pretendard-Bold.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 600;
		font-display: swap;
		src:local("Pretendard SemiBold"), url("/Pretendard/Pretendard-SemiBold.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 500;
		font-display: swap;
		src:local("Pretendard Medium"), url("/Pretendard/Pretendard-Medium.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 400;
		font-display: swap;
		src:local("Pretendard Regular"), url("/Pretendard/Pretendard-Regular.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 300;
		font-display: swap;
		src:local("Pretendard Light"), url("/Pretendard/Pretendard-Light.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 200;
		font-display: swap;
		src:local("Pretendard ExtraLight"), url("/Pretendard/Pretendard-ExtraLight.woff2"), format('woff2');
	}

	@font-face {
		font-family: 'Pretendard';
		font-weight: 100;
		font-display: swap;
		src:local("Pretnedard Thin"), url("/Pretendard/Pretendard-Thin.woff2"), format('woff2');
	}
`;
